import IdeyaModal from '../../../../../common/antd/ideya-modal.tsx'
import {
  useGetDailyIdeaPnlQuery,
  useGetIdeaHistoryQuery,
} from '../../../../../apis/idea/idea-api.api.ts'
import { IdeyaSpinner } from '../../../../../common/components/ideya-spinner.tsx'
import { IdeaHistory } from './idea-history.tsx'
import { IdeyaButton } from '../../../../../common/antd/ideya-button.tsx'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'

interface IdeaHistoryModalProps {
  showHistoryModal: boolean
  ideaId?: string | null
  handleCloseModal: () => void
}

export const IdeaHistoryModal: React.FC<IdeaHistoryModalProps> = ({
  showHistoryModal,
  ideaId,
  handleCloseModal,
}) => {
  const [showContent, setShowContent] = useState<boolean>(false)
  const { t } = useTranslation()
  const {
    currentData: historyData,
    isLoading: isLoadingHistory,
    isFetching: isFetchingHistory,
  } = useGetIdeaHistoryQuery(ideaId ?? '', { skip: !ideaId })

  const {
    currentData: pnlData,
    isLoading: isLoadingPnl,
    isFetching: isFetchingPnl,
  } = useGetDailyIdeaPnlQuery(ideaId ?? '', { skip: !ideaId })

  // Only show contents after modal is fully rendered
  const handleAfterOpenChange = (visible: boolean) => {
    setShowContent(visible)
  }

  return (
    <IdeyaModal
      title={
        pnlData
          ? pnlData?.data.ticker.tickerCode + ' ' + pnlData?.data.ticker.name
          : ''
      }
      open={showHistoryModal}
      width={900}
      onCancel={() => {
        handleCloseModal()
        setShowContent(false)
      }}
      afterOpenChange={handleAfterOpenChange}
      footer={
        <IdeyaButton onClick={handleCloseModal}>
          {t('common.got_it')}
        </IdeyaButton>
      }
    >
      <div
        style={{
          height: 700,
          overflow: 'auto',
        }}
      >
        {isFetchingHistory ||
        isLoadingHistory ||
        isLoadingPnl ||
        isFetchingPnl ? (
          <IdeyaSpinner />
        ) : historyData?.data && pnlData?.data && showContent ? (
          <IdeaHistory historyData={historyData.data} pnlData={pnlData.data} />
        ) : null}
      </div>
    </IdeyaModal>
  )
}
